import React from 'react'

type DropdownArrowIcon = {
  className?: string
}

const DropdownArrowIcon = ({ className }: DropdownArrowIcon) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path fill="currentColor" d="M7 10l5 5 5-5H7z"></path>
    </svg>
  )
}

export default DropdownArrowIcon
